const ScratchStorage = require('./ScratchStorage');

/**
 * Export for use with NPM & Node.js.
 * @type {ScratchStorage}
 */
module.exports = ScratchStorage;
